import React from 'react';
import { Button } from '../../globalStyles';
import { AiFillThunderbolt } from 'react-icons/ai';
import { GiCrystalBars } from 'react-icons/gi';
import { GiCutDiamond, GiRock } from 'react-icons/gi';
import { GiFloatingCrystal } from 'react-icons/gi';
import { IconContext } from 'react-icons/lib';
import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  PricingCardCost,
  PricingCardLength,
  PricingCardFeatures,
  PricingCardFeature
} from './Pricing.elements';

function Pricing() {
  return (
    <IconContext.Provider value={{ color: '#a9b3c1', size: 64 }}>
      <PricingSection>
        <PricingWrapper>
          <PricingHeading>Our Services</PricingHeading>
          <PricingContainer>
            <PricingCard to='/buy'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiRock />
                </PricingCardIcon>
                <PricingCardPlan>Starter Caller</PricingCardPlan>
                <PricingCardCost>$5.00</PricingCardCost>
                <PricingCardFeatures>
                  <PricingCardFeature>No Bonus</PricingCardFeature>
                  <PricingCardFeature>870 Credits</PricingCardFeature>
                  <PricingCardFeature>Worldwide calling</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>Buy Now</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/buy'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiCrystalBars />
                </PricingCardIcon>
                <PricingCardPlan>Basic Caller</PricingCardPlan>
                <PricingCardCost>$10.00</PricingCardCost>
                <PricingCardFeatures>
                  <PricingCardFeature>No Bonus</PricingCardFeature>
                  <PricingCardFeature>1740 Credits</PricingCardFeature>
                  <PricingCardFeature>Worldwide calling</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>Buy Now</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/buy'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiCutDiamond />
                </PricingCardIcon>
                <PricingCardPlan>Professional Caller</PricingCardPlan>
                <PricingCardCost>$15.00</PricingCardCost>
                <PricingCardFeatures>
                  <PricingCardFeature>Inc. Bonus</PricingCardFeature>
                  <PricingCardFeature>2610 Credits</PricingCardFeature>
                  <PricingCardFeature>70 Bonus Credits</PricingCardFeature>
                  <PricingCardFeature>Most Popular</PricingCardFeature>
                  <PricingCardFeature>Worldwide calling</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>Buy Now</Button>
              </PricingCardInfo>
            </PricingCard>
          </PricingContainer>
          {/* Second Row */}
          <PricingContainer>
            <PricingCard to='/buy'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiRock />
                </PricingCardIcon>
                <PricingCardPlan>Professional Caller</PricingCardPlan>
                <PricingCardCost>$20.00</PricingCardCost>
                <PricingCardFeatures>
                  <PricingCardFeature>Inc. Bonus</PricingCardFeature>
                  <PricingCardFeature>3480 Credits</PricingCardFeature>
                  <PricingCardFeature>120 Bonus Credits</PricingCardFeature>
                  <PricingCardFeature>Worldwide calling</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>Buy Now</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/buy'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiCrystalBars />
                </PricingCardIcon>
                <PricingCardPlan>Professional Caller</PricingCardPlan>
                <PricingCardCost>$25.00</PricingCardCost>
                <PricingCardFeatures>
                  <PricingCardFeature>Inc. Bonus</PricingCardFeature>
                  <PricingCardFeature>4350 Credits</PricingCardFeature>
                  <PricingCardFeature>150 Bonus Credits</PricingCardFeature>
                  <PricingCardFeature>Worldwide calling</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>Buy Now</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/buy'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiCutDiamond />
                </PricingCardIcon>
                <PricingCardPlan>Premium Caller</PricingCardPlan>
                <PricingCardCost>$40.00</PricingCardCost>
                <PricingCardFeatures>
                  <PricingCardFeature>Inc. Bonus</PricingCardFeature>
                  <PricingCardFeature>6960 Credits</PricingCardFeature>
                  <PricingCardFeature>230 Bonus Credits</PricingCardFeature>
                  <PricingCardFeature>Best Value</PricingCardFeature>
                  <PricingCardFeature>Worldwide calling</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>Buy Now</Button>
              </PricingCardInfo>
            </PricingCard>
          </PricingContainer>
        </PricingWrapper>
      </PricingSection>
    </IconContext.Provider>
  );
}
export default Pricing;
